import RadioOption from '~/components/RadioOption';
import CompactEventTypeSelect from '~/components/forms/CompactEventTypeSelect';
import EventTypeCheckboxes from '~/components/EventTypeCheckboxes';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import {usePackagesQuery} from "~/lib/Queries";
import {PackageTypes} from "~/lib/PackageHelpers";


const PackageSelectionRow = ({p, onChange, value}) => {
    const isChecked = value.indexOf(p.id) > -1;

    function toggle()
    {
        if (isChecked) {
            onChange(value.filter((v) => v !== p.id));
        } else {
            onChange([...value, p.id])
        }
    }

    console.log('p=', p)

    return (
        <label className="flex items-center py-2">
            <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => toggle()}
                className="mr-2"
            />
            <div className="flex">
                <div className="mr-2">{p.name}</div>
                <div className="text-gray-500">
                    ({formatCurrency(p.price)})
                    {isChecked && p.type === PackageTypes.SUBSCRIPTION && (
                        <div>Coupon will discount first payment only{parseFloat(p.subscription_settings?.setupFee)>0 ? ' and also not discount setup fees' : ''}</div>
                    )}
                </div>
            </div>
        </label>
    )
}


const AppliesToInput = ({ value, onChange }) => {
    const { data : packagesData } = usePackagesQuery('');
    const packages = packagesData?.packages || [];

    return (
        <div className="panel px-4 py-2">
            {packages.length > 0 && (
                <h3>Event Types</h3>
            )}

            <EventTypeCheckboxes
                id="coupon.applies_to"
                onChange={newValue =>
                    onChange({ ...value, eventTypes: newValue })
                }
                value={value?.eventTypes}
                renderLabel={({ opt }) => (
                    <div className="flex">
                        <div className="mr-2">{opt.label}</div>
                        <div className="text-gray-500">
                            ({formatCurrency(opt.type?.price)})
                        </div>
                    </div>
                )}
            />

            {packages.length > 0 && (
                <div className="mt-2">
                    <h3>Packages &amp; Subscriptions</h3>
                    {packages.map((p) => (
                        <PackageSelectionRow
                            p={p}
                            key={p.id}
                            onChange={newValue =>
                                onChange({ ...value, packages: newValue })
                            }
                            value={value?.packages || []}
                        />
                    ))}
                </div>
            )}

        </div>
    );
};

export default AppliesToInput;
